"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const doFetchData = async (service) => {
    const [alerts, sources, sourceGroups, targetGroups, emailTargets, smsTargets, telegramTargets,] = await Promise.all([
        service.getAlerts(),
        service.getSources(),
        service.getSourceGroups(),
        service.getTargetGroups(),
        service.getEmailTargets(),
        service.getSmsTargets(),
        service.getTelegramTargets(),
    ]);
    const filterIds = new Set();
    const filters = [];
    sources.forEach((source) => {
        source.applicableFilters.forEach((filter) => {
            if (!filterIds.has(filter.id)) {
                filters.push(filter);
                filterIds.add(filter.id);
            }
        });
    });
    return {
        alerts: [...alerts],
        filters,
        sources: [...sources],
        sourceGroups: [...sourceGroups],
        targetGroups: [...targetGroups],
        emailTargets: [...emailTargets],
        smsTargets: [...smsTargets],
        telegramTargets: [...telegramTargets],
    };
};
const DataTtlMs = 1000;
const fetchDataImpl = async (service, timeProvider, state) => {
    if (state.pendingPromise !== undefined) {
        return await state.pendingPromise;
    }
    if (state.lastSuccessTime !== undefined &&
        state.lastSuccessData !== undefined) {
        const currentTime = timeProvider.now();
        if (currentTime <= state.lastSuccessTime + DataTtlMs) {
            return state.lastSuccessData;
        }
    }
    const promise = doFetchData(service);
    state.pendingPromise = promise;
    const results = await promise;
    state.pendingPromise = undefined;
    state.lastSuccessTime = timeProvider.now();
    state.lastSuccessData = results;
    return results;
};
exports.default = fetchDataImpl;
//# sourceMappingURL=data:application/json;base64,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